import React, { useEffect, useMemo } from "react";
import { Button, Card, Form, Input, message } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faPlus } from "@fortawesome/free-solid-svg-icons";
import { InputClass } from "Utility/Contants/Styles";
import { useSelector } from "react-redux";
import { getUserDetailsFromReducer } from "Store/reducers/Auth/AuthSlice";
import { updateAccountDetails } from "Sdk/Actions";
import { NormalizeLink } from "Utility/Common/Methods";

export const GetActionLinks = () => {
  const userDetails = useSelector(getUserDetailsFromReducer);
  const userName = userDetails.username;

  const initialLinks = useMemo(() => {
    return userDetails?.action ? JSON.parse(userDetails?.action) : [];
  }, [userDetails?.action]);

  const [form] = Form.useForm();

  // Update form values when initialLinks changes
  useEffect(() => {
    form.setFieldsValue({ items: initialLinks });
  }, [initialLinks, form]);

  const handleSubmit = async (values) => {
    try {
      const normalizedActionLinks = values?.items?.map((item) => ({
        name: item?.name,
        link: NormalizeLink(item?.link),
      }));

      const userData = {
        username: userName,
        action: JSON.stringify(normalizedActionLinks),
      };

      await updateAccountDetails(userData);
    } catch (error) {
      console.error("Failed to update action links:", error);
    } finally {
      message.success("Action links updated successfully!");
    }
  };

  return (
    <div>
      <Form
        form={form}
        name="dynamic_form_complex"
        layout="horizontal"
        onFinish={handleSubmit}
        initialValues={{
          items: initialLinks, // Initialize form with current links
        }}
        className="gap-0 p-0"
        autoComplete="off"
      >
        <Form.List name="items">
          {(fields, { add, remove }) => (
            <div>
              {fields?.map((field) => (
                <Card
                  size="small"
                  title={
                    form?.getFieldValue(["items", field?.name, "name"]) ||
                    `Link ${field.name + 1}`
                  }
                  className="mb-5 border-2 border-primary "
                  key={field.key}
                  extra={
                    <FontAwesomeIcon
                      icon={faClose}
                      onClick={() => remove(field?.name)}
                      className="cursor-pointer"
                    />
                  }
                >
                  <div className="w-full">
                    {/* Name Input */}

                    <Form.Item
                      label="Name"
                      name={[field?.name, "name"]}
                      rules={[
                        { required: true, message: "Please enter a name" },
                      ]}
                    >
                      <Input
                        placeholder="Enter link name"
                        className={`${InputClass}`}
                      />
                    </Form.Item>

                    {/* Link Input */}
                    <Form.Item
                      label="Link"
                      name={[field?.name, "link"]}
                      rules={[
                        {
                          required: true,
                          message: "Please enter a valid URL",
                        },
                        {
                          validator: (_, value) => {
                            if (
                              !value ||
                              /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/.*)?$/.test(
                                value
                              )
                            ) {
                              return Promise.resolve();
                            }
                            return Promise.reject(
                              new Error("Please enter a valid URL")
                            );
                          },
                        },
                      ]}
                    >
                      <Input
                        placeholder="Enter link URL"
                        className={`${InputClass}`}
                      />
                    </Form.Item>
                  </div>
                </Card>
              ))}
              <Button
                type="dashed"
                size="middle"
                onClick={() => add()}
                block
                className="border-1"
              >
                + Add more links
              </Button>
            </div>
          )}
        </Form.List>
        <Button
          type="primary"
          htmlType="submit"
          className="mt-5 text-center"
          size="middle"
          block
          icon={<FontAwesomeIcon icon={faPlus} />}
        >
          Add Links
        </Button>
      </Form>
    </div>
  );
};
